import React, { useState } from "react";
import { socials } from "../../v3/data";

const ContactFooter = () => {
  const [sent, setSent] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const name = data.get("name") || "";
    const email = data.get("email") || "";
    const company = data.get("company") || "";
    const country = data.get("country") || "";
    const phone = data.get("phone") || "";
    const message = data.get("message") || "";
    const details = [
      company && `Company: ${company}`,
      country && `Country: ${country}`,
      phone && `Phone: ${phone}`,
    ]
      .filter(Boolean)
      .join("\n");
    const subject = encodeURIComponent(`Project inquiry from ${name || "your website"}`);
    const body = encodeURIComponent(`${message}\n\n— ${name}${email ? ` (${email})` : ""}${details ? `\n${details}` : ""}`);
    window.location.href = `mailto:contact@mohsin-idrees.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <footer id="contact" className="section" style={{ paddingBottom: 0 }}>
      <div className="pagewrap contact-grid">
        <div>
          <div className="snum">[ 07 / CONTACT ]</div>
          <h2 className="h2" style={{ marginBottom: 22 }}>
            Let's build
            <br />
            something.
          </h2>
          <p className="lead" style={{ maxWidth: 400, margin: "0 0 30px" }}>
            Working remotely with clients worldwide. Email me or send a message; I reply within 3 hours.
          </p>
          <div className="col gap10" style={{ marginBottom: 28, maxWidth: 440 }}>
            {socials.map((s) => (
              <a key={s.label} href={s.href} className="soclink" target="_blank" rel="noreferrer">
                <span className="icobox">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d={s.icon} />
                  </svg>
                </span>
                <span className="col" style={{ gap: 1 }}>
                  <span className="mono" style={{ fontSize: 10.5, color: "var(--muted)", letterSpacing: ".08em" }}>
                    {s.label}
                  </span>
                  <span className="fw6" style={{ fontSize: 14, color: "var(--ink)" }}>
                    {s.value}
                  </span>
                </span>
                <span className="mono" style={{ marginLeft: "auto", color: "var(--muted)", fontSize: 13 }}>
                  ↗
                </span>
              </a>
            ))}
          </div>
          <a href="#top" className="btn btn-primary" style={{ width: "max-content" }}>
            Book a call<span className="arr">→</span>
          </a>
        </div>

        <form className="card col gap16" style={{ padding: 36 }} onSubmit={onSubmit}>
          <div>
            <label className="flabel">NAME</label>
            <input name="name" placeholder="Your name" className="field" />
          </div>
          <div>
            <label className="flabel">EMAIL</label>
            <input name="email" type="email" placeholder="you@company.com" className="field" />
          </div>
          <div className="fx gap12 wrap">
            <div style={{ flex: 1, minWidth: 150 }}>
              <label className="flabel">COMPANY · OPTIONAL</label>
              <input name="company" placeholder="Company name" className="field" />
            </div>
            <div style={{ flex: 1, minWidth: 150 }}>
              <label className="flabel">COUNTRY · OPTIONAL</label>
              <input name="country" placeholder="Where are you based?" className="field" />
            </div>
          </div>
          <div>
            <label className="flabel">PHONE · OPTIONAL</label>
            <input name="phone" type="tel" placeholder="+1 (555) 000-0000" className="field" />
          </div>
          <div>
            <label className="flabel">MESSAGE</label>
            <textarea name="message" rows="4" placeholder="What's slow, manual, or missing?" className="field" style={{ resize: "vertical" }} />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: "100%" }}>
            {sent ? "Message sent ✓" : "Send message"}
          </button>
          <p className="tc" style={{ fontSize: 12.5, lineHeight: 1.6, color: "var(--muted)", margin: 0 }}>
            Viewing my portfolio through an Upwork job post? Kindly contact me there on{" "}
            <a href="https://www.upwork.com/freelancers/~01990863ba7110b5a9" target="_blank" rel="noreferrer">
              Upwork
            </a>{" "}
            instead.
          </p>
        </form>
      </div>

      <div
        className="pagewrap fx jb ac wrap gap12 mono"
        style={{ marginTop: 72, padding: "26px 0", borderTop: "1px solid var(--line)", color: "var(--muted)", fontSize: 12 }}
      >
        <div>© {new Date().getFullYear()} MOHSIN IDREES — ALL RIGHTS RESERVED</div>
        <div className="fx gap10">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="socbtn"
              style={{ width: 34, height: 34, borderRadius: 8 }}
              title={s.label}
              target="_blank"
              rel="noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 15, height: 15 }}>
                <path d={s.icon} />
              </svg>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default ContactFooter;
